/* eslint-disable simple-import-sort/imports */
import React from 'react';
import { styled } from 'styled-components';

import { dataLogoCarousel } from 'pages/Home/Sections/LogoCarousel/data-LogoCarousel';

import { Reveal, Stagger, StaggerItem } from '../components/Motion';
import { Container, v2 } from '../v2';

const Wrapper = styled.section`
  position: relative;
  padding: 56px 0 72px;
  background: ${v2.bg};
  border-top: 1px solid ${v2.border};
`;

const Label = styled.div`
  text-align: center;
  font-family: ${v2.fontBody};
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: ${v2.textFaint};
  margin-bottom: 36px;
`;

const Wall = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  max-width: 1060px;
  margin: 0 auto;
`;

const LogoChip = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 68px;
  padding: 12px 28px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid ${v2.border};
  filter: grayscale(1);
  opacity: 0.82;
  transition:
    filter 0.3s ease,
    opacity 0.3s ease,
    transform 0.3s ease,
    box-shadow 0.3s ease;

  img {
    height: 36px;
    width: auto;
    max-width: 140px;
    object-fit: contain;
  }

  &:hover {
    filter: grayscale(0);
    opacity: 1;
    transform: translateY(-3px);
    box-shadow: 0 14px 36px rgba(0, 0, 0, 0.35);
  }

  @media (max-width: 480px) {
    height: 56px;
    padding: 10px 18px;

    img {
      height: 28px;
      max-width: 110px;
    }
  }
`;

const LogoWall = () => (
  <Wrapper>
    <Container>
      <Reveal>
        <Label>{dataLogoCarousel.title}</Label>
      </Reveal>
      <Stagger gap={0.05}>
        <Wall>
          {dataLogoCarousel.logos.map((logo) => (
            <StaggerItem key={logo.src} y={18}>
              <LogoChip href={logo.href} target="_blank" rel="noreferrer">
                <img src={logo.src} alt={logo.alt} loading="lazy" />
              </LogoChip>
            </StaggerItem>
          ))}
        </Wall>
      </Stagger>
    </Container>
  </Wrapper>
);

export default LogoWall;
